import React, { Component } from 'react'
import { Button, Popconfirm, message } from 'antd';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import SearchRetrieve from '../../common/SearchRetrieve.new'
import UpdataModal from './UpdataModal';
import TableC from '../../basicElement/TableC';
import SideNav from '../SideNav';
import fp from '../../../utils/fp';

export default class identificationCode extends Component {
    state = {
        data:[],
        loading:false,
        canAdd:false,
        searchParams:{},
        pagination: {
            pageSize: 10,
            current: 1,
        },
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        const { searchParams, pagination } = this.state;
        const { current, pageSize } = pagination;
        this.setState({ loading:true })
        const options = {
            method: 'POST',
            url: API_URL.contract.queryInvIdentifyCodeList,
            data: {
                offset: current,
                limit: pageSize,
                ...searchParams,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas = [] } = res;
                const someRole = fp.contains(sessionStorage.curRole);
                const canAdd = someRole(['BO','BA','BAL'])
                datas.forEach(( el, index ) => {
                    el.indexNum = index + 1
                })
                this.setState({ data: datas, loading:false, canAdd })
            },
        };
        $.sendRequest(options);
    }

    add =  () => {
        this.updataModalRef.show({}, 'add')
    }

    update = ( record, type ) => {
        this.updataModalRef.show(record, type)
    }

    delete = investigationIdentifyCodeId => {
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.contract.delInvIdentifyCode,
            data: { investigationIdentifyCodeId },
            dataType: 'json',
            doneResult: res => {
                message.success(res.success);
                this.loadData();
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handleChange = (value, key) => {
        const { searchParams } = this.state;
        switch (key) {
            case 'identifyCode':
            {
                const { value: id, text: name } = value;
                searchParams[`${key}Id`] = id;
                searchParams[`${key}Name`] = name;
                searchParams[`${key}`] = name;
                this.setState({searchParams})
                break;
            }
            default:
                searchParams[key] = value;
                this.setState({searchParams})
                break;
        }
    }

    handleTableChange = ( params ) => {
        const { pagination } = params;
        this.setStat({ pagination })
    }

    getColumns = () => {
        const { canAdd } = this.state;
        const columns = [{
            title: '序号',
            dataIndex: 'indexNum',
            key: 'indexNum',
            width: 100,
        },{
            title: '项目识别码',
            dataIndex: 'identifyCode',
            key: 'identifyCode',
            width: 200,
        },{
            title: '操作',
            dataIndex: 'operate',
            key: 'operate',
            width: 120,
            render: ( text, record, index ) => {
                return (
                    <span>
                        {
                            canAdd &&
                                <span>
                                    <a onClick={() => this.update(record, 'edit')}>修改</a>
                                    <span className="ant-divider" />
                                </span>
                        }
                        {
                            canAdd &&
                                <Popconfirm title="确定要删除?" onConfirm={() => this.delete(record.investigationIdentifyCodeId)}>
                                    <a>删除</a>
                                </Popconfirm>
                        }
                        {
                            !canAdd && <span>-</span>
                        }
                    </span>
                )
            } 
        }]
        return columns
    }

    render() {
        const { searchParams, data, pagination, loading, canAdd } = this.state;
        return (
            <div className="content">
                <SideNav selectKey='identificationCode' />
                <div  className="main">
                    <div style={{marginBottom: 16}}>
                        <div className='search-bar'>
                            <div className="search-item">
                                <div className="ui-label">项目识别码</div>
                                <SearchRetrieve
                                    keyword='identifyCode'
                                    style={{ width: 160 }}
                                    placeholder="输入名称检索"
                                    value={searchParams.identifyCode}
                                    params={{ limit: 20 }}
                                    url={API_URL.contract.queryInvIdentifyCodeList}
                                    config={{ id: 'investigationIdentifyCodeId', name: 'identifyCode' }}
                                    onChange={(option) => this.handleChange(option, 'identifyCode')}
                                />
                            </div>
                            <div className="search-item">
                                <Button key="export" type="primary" onClick={this.loadData}>搜索</Button>
                                {
                                    canAdd && <Button key="add" type="primary" onClick={this.add}>添加</Button>
                                }
                            </div>
                        </div>
                        
                    </div>
                    <TableC
                        data={data}
                        loading={loading}
                        columns={this.getColumns()}
                        pagination={pagination}
                        onChange={this.handleTableChange}
                    />
                </div>
                <UpdataModal ref={ el => this.updataModalRef = el } loadData={this.loadData}/>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/contractManagement/IdentificationCode/index.js